import { NgModule } from "@angular/core";
import { RouterModule } from '@angular/router';
import { CommonModule } from "@angular/common";
import { IonicModule } from '@ionic/angular';
import { HeaderWavesComponent } from './header-waves-container.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        RouterModule.forChild([
            { path: '', component: HeaderWavesComponent },
        ]),
    ],
    exports:[HeaderWavesComponent],
    declarations:[HeaderWavesComponent]
})
export class HeaderWavesComponentModule { }